import React from "react";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import { ReactComponent as CalendarIcon } from "../../resources/images/svg/home/calendar.svg";

const EventDate = ({ date, ...props }) => {
  const date1 = React.useMemo(() => {
    if (date) return moment.unix(date.dateDebut);
    return null;
  }, [date]);

  const date2 = React.useMemo(() => {
    if (date) return moment.unix(date.dateFin);
    return null;
  }, [date]);

  const isSameDay = React.useMemo(() => {
    return date1 && date2 && date1?.format("LL") === date2?.format("LL");
  }, [date1, date2]);

  const text = React.useMemo(() => {
    const now = moment();
    if (!date1 || !date2 || date2.isBefore(now))
      return `Aucune date annoncée pour le moment`;
    return !isSameDay
      ? `Du ${date1.format("LL[ ]HH[h]mm")} au ${date2.format("LL[ ]HH[h]mm")}`
      : `Le ${date1.format("LL")}, de ${date1.format("HH[h]mm")} à ${date2.format("HH[h]mm")}`;
  }, [isSameDay, date1, date2]);

  return (
    <Box
      {...props}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        ...props.sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "55px",
          height: "55px",
          background: "#0D0034",
          borderRadius: "50%",
          marginRight: 2,
        }}
      >
        <CalendarIcon />
      </Box>
      <Typography
        sx={{
          color: (theme) => theme.palette.blackPro,
          fontSize: 18,
          fontWeight: "bold",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default EventDate;
